import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from '../client';
import type {
  RecurringTransactionListResponseApi,
  RecurringTransactionApi,
  CreateRecurringTransactionRequestApi,
  UpdateRecurringTransactionRequestApi,
} from '../models/recurringTransaction';

export async function getAllRecurringTransactions(): Promise<RecurringTransactionListResponseApi> {
  return apiGet<RecurringTransactionListResponseApi>('recurring-transactions');
}

export async function getRecurringTransactionById(id: number): Promise<RecurringTransactionApi | null> {
  try {
    return await apiGet<RecurringTransactionApi>(`recurring-transactions/${id}`);
  } catch (error) {
    if (error instanceof Error && 'status' in error && (error as { status: number }).status === 404) {
      return null;
    }
    throw error;
  }
}

export async function createRecurringTransaction(
  request: CreateRecurringTransactionRequestApi
): Promise<RecurringTransactionApi> {
  return apiPost<RecurringTransactionApi>('recurring-transactions', request);
}

export async function updateRecurringTransaction(
  id: number,
  request: UpdateRecurringTransactionRequestApi
): Promise<RecurringTransactionApi> {
  return apiPut<RecurringTransactionApi>(`recurring-transactions/${id}`, request);
}

export async function deleteRecurringTransaction(id: number): Promise<void> {
  return apiDelete<void>(`recurring-transactions/${id}`);
}

export async function updateRecurringTransactionCategory(id: number, category: string): Promise<void> {
  return apiPatch<void>(`transactions/recurring/${id}/category`, { category });
}
